module.exports = __webpack_public_path__ + "static/img/icon_qiye.bdf2038c.png";